import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AnimateOnScroll from "./AnimateOnScroll";

export default function RegisterSection() {
  const navigate = useNavigate();
  const location = useLocation();

  const loadForm = () => {
    const script = document.createElement("script");
    script.src = "//js-eu1.hsforms.net/forms/embed/v2.js";
    script.type = "text/javascript";
    script.charset = "utf-8";

    script.onload = () => {
      if ((window as any).hbspt) {
        (window as any).hbspt.forms.create({
          region: "eu1",
          portalId: "25229919",
          formId: "8ae5feed-3f03-4724-9e8b-c364043b51ca",
          target: "#hubspotFormContainer",
          onFormReady: ($form: any) => {
            const button = $form.querySelector(".hs-button");
            if (button) {
              button.style.backgroundColor = "rgb(0, 0, 0)";
              button.style.borderRadius = "24px";
              button.style.border = "0";
              button.style.width = "100%";
              button.style.fontSize = "16px";
              button.style.padding = "16px";
            }
            const textAll = $form.querySelectorAll(".hs-richtext");
            if (textAll) {
              textAll.forEach((el: HTMLElement) => {
                el.style.fontSize = "12px";
                el.style.lineHeight = "1.1em";
                el.style.color = "rgba(0,0,0,0.5)";
              });
            }

            const labelAll = $form.querySelectorAll("label");
            if (labelAll) {
              labelAll.forEach((el: HTMLElement) => {
                el.style.fontSize = "14px";
                el.style.color = "#555";
              });
            }

            const inputAll = $form.querySelectorAll(".hs-input:not(input[type=checkbox])");
            if (inputAll) {
              inputAll.forEach((el: HTMLElement) => {
                // el.style.border = "0";
                el.style.backgroundColor = "rgb(253, 250, 246)";
                el.style.height = "36px";
              });
            }
          },
        });
      }
    };

    document.body.appendChild(script);
  };

  useEffect(() => {
    loadForm();
  }, []);

  // const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
  //   e.preventDefault();
  //   const form = e.currentTarget;
  //   const data = new FormData(form);
  //   const params = new URLSearchParams();
  //   data.forEach((val, key) => params.append(key, val.toString()));
  //   setStatus("sending");
  //   try {
  //     const res = await fetch(
  //       "https://readdy.ai/api/form/d719mbghb0rqicn68dbg",
  //       {
  //         method: "POST",
  //         headers: { "Content-Type": "application/x-www-form-urlencoded" },
  //         body: params.toString(),
  //       },
  //     );
  //     if (res.ok) {
  //       setStatus("success");
  //       form.reset();
  //     } else setStatus("error");
  //   } catch {
  //     setStatus("error");
  //   }
  // };

  const scrollTo = (href: string) => {
    if (href === "#co-creator") {
      // CoCreatorSection lives at /co-creator now
      if (location.pathname === "/co-creator") {
        const el = document.querySelector(href);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      } else {
        navigate("/co-creator");
      }
      return;
    }
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="register" className="bg-[#EFEBE5] py-24">
      <div className="max-w-6xl mx-auto px-6">
        <AnimateOnScroll variant="fade-up">
          <div className="text-center mb-14">
            <p className="text-xs font-bold tracking-widest text-brown-300 uppercase mb-4">
              Join the Programme
            </p>
          </div>
        </AnimateOnScroll>

        <AnimateOnScroll variant="zoom-in" delay={80}>
          <div className="grid grid-cols-1 lg:grid-cols-5 rounded-2xl shadow-lg overflow-hidden ">
            {/* Left panel */}
            <div className="lg:col-span-2 relative bg-[#060610] overflow-hidden">
              {/* ── VISUAL LAYER ─────────────────────────── */}

              {/* Primary radial amber glow — upper-centre */}
              <div
                className="absolute inset-0 pointer-events-none"
                style={{
                  background:
                    "radial-gradient(ellipse 130% 55% at 50% 18%, rgba(245,158,11,0.25) 0%, rgba(245,158,11,0.08) 45%, transparent 70%)",
                }}
              />
              {/* Secondary glow — lower-left warmth */}
              <div
                className="absolute inset-0 pointer-events-none"
                style={{
                  background:
                    "radial-gradient(ellipse 80% 50% at 5% 95%, rgba(245,158,11,0.14) 0%, transparent 60%)",
                }}
              />
              {/* Dark vignette edges */}
              <div
                className="absolute inset-0 pointer-events-none"
                style={{
                  background:
                    "radial-gradient(ellipse 100% 100% at 50% 50%, transparent 50%, rgba(0,0,0,0.55) 100%)",
                }}
              />

              {/* Dot grid */}
              <div
                className="absolute inset-0 pointer-events-none"
                style={{
                  opacity: 0.045,
                  backgroundImage:
                    "radial-gradient(circle, rgba(255,255,255,0.9) 1px, transparent 1px)",
                  backgroundSize: "26px 26px",
                }}
              />

              {/* Bottom content fade */}
              <div
                className="absolute inset-x-0 bottom-0 h-72 pointer-events-none"
                style={{
                  background:
                    "linear-gradient(to top, #060610 0%, #060610 30%, rgba(6,6,16,0.85) 60%, transparent 100%)",
                }}
              />

              {/* Crown centrepiece */}
              <div
                className="absolute inset-x-0 pointer-events-none"
                style={{
                  top: "20%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div className="relative flex items-center justify-center w-28 h-28">
                  {/* Pulsing rings */}
                  {[0, 0.85, 1.7].map((delay, i) => (
                    <div
                      key={i}
                      className="absolute inset-0 rounded-full border border-amber-400/50"
                      style={{
                        animation: `pulse-ring 2.6s ease-out ${delay}s infinite`,
                      }}
                    />
                  ))}
                  <img />
                  {/* Soft bloom behind crown */}
                  <div
                    className="absolute w-32 h-32 rounded"
                    style={{
                      background:
                        "radial-gradient(circle, rgba(245,158,11,0.22) 0%, transparent 70%)",
                    }}
                  />
                  {/* Crown circle */}
                  <div
                    className="relative w-20 h-20 rounded-full flex items-center justify-center border border-amber-400/30"
                    style={{
                      background:
                        "linear-gradient(135deg, rgba(245,158,11,0.18) 0%, rgba(245,158,11,0.06) 100%)",
                      animation: "shimmer-crown 3s ease-in-out infinite",
                    }}
                  >
                    <i className="ri-vip-crown-fill text-4xl text-amber-400" />
                  </div>
                </div>
              </div>

              {/* Floating badge — price (clickable → Co-Creator section) */}
              {/* <button
                onClick={() => scrollTo("#co-creator")}
                className="absolute cursor-pointer"
                style={{
                  top: "11%",
                  right: "2rem",
                  animation: "float-badge 4.2s ease-in-out 0s infinite",
                }}
              >
                <div
                  className="rounded px-3 py-2.5 border border-white/12 hover:border-amber-400/50 transition-colors"
                  style={{
                    background: "rgba(255,255,255,0.06)",
                    backdropFilter: "blur(8px)",
                  }}
                >
                  <p className="text-xl font-extrabold text-white leading-none">
                    £3.25
                  </p>
                  <p className="text-[10px] text-amber-400 font-semibold whitespace-nowrap mt-0.5">
                    /month · per end user
                  </p>
                  <p className="text-[9px] text-amber-400/55 font-medium whitespace-nowrap mt-0.5">
                    *through 2026
                  </p>
                </div>
              </button> */}

              {/* Floating badge — discount */}
              {/* <div
                className="absolute"
                style={{
                  top: "11%",
                  left: "2rem",
                  animation: "float-badge 4.2s ease-in-out 0.6s infinite",
                }}
              >
                <div
                  className="rounded px-3 py-2.5 text-center border border-amber-400/30"
                  style={{
                    background: "rgba(245,158,11,0.12)",
                    backdropFilter: "blur(8px)",
                  }}
                >
                  <p className="text-xl font-extrabold text-amber-300 leading-none">
                    75%
                  </p>
                  <p className="text-[10px] text-amber-400/80 font-semibold">
                    OFF
                  </p>
                </div>
              </div> */}

              {/* Scattered particles */}
              {[
                { top: "7%", left: "38%", delay: "0s", size: 6 },
                { top: "16%", left: "72%", delay: "0.6s", size: 5 },
                { top: "34%", left: "12%", delay: "1.1s", size: 4 },
                { top: "42%", left: "85%", delay: "0.3s", size: 5 },
                { top: "60%", left: "22%", delay: "1.5s", size: 4 },
                { top: "30%", left: "76%", delay: "0.9s", size: 4 },
                { top: "22%", left: "28%", delay: "0.4s", size: 3 },
              ].map((p, i) => (
                <div
                  key={i}
                  className="absolute rounded bg-amber-400/40 pointer-events-none"
                  style={{
                    top: p.top,
                    left: p.left,
                    width: p.size,
                    height: p.size,
                    animation: `drift-particle 5s ease-in-out ${p.delay} infinite`,
                  }}
                />
              ))}

              {/* ── CONTENT LAYER ─────────────────────────── */}
              <div className="relative flex w-full z-20 p-10 pb-14 lg:pb-10 min-h-[480px] lg:min-h-[660px]">
                <div className="flex flex-col flex-1 min-w-0 justify-between">
                  {/* <div className="flex items-center gap-2 mb-6">
                    <span className="text-2xl font-bold text-white tracking-tight">
                      Envizage
                    </span>
                    <span className="text-xs font-semibold bg-white/20 text-white px-1.5 py-0.5 rounded">
                      AI
                    </span>
                  </div> */}
                  <div className="inline-flex items-center gap-2 bg-amber-400/15 border border-amber-400/30 rounded-2xl px-3 py-1.5 mb-5 max-w-full">
                    <i className="ri-vip-crown-line text-xs text-amber-400 flex-shrink-0" />
                    <span className="text-xs font-semibold text-amber-300 tracking-wide">
                      Co-Creator Founding Offer — 75% off through 2026
                    </span>
                  </div>
                  <div>
                    <h3 className="text-2xl lg:text-3xl font-bold text-white leading-tight mb-4">
                      Become a Co-Creator. Shape the future of financial
                      planning.
                    </h3>
                    <p className="text-md text-white/70 leading-relaxed">
                      Register your interest to join our founding Co-Creator
                      programme — get early access to the MVP, influence the
                      roadmap directly, and lock in{" "}
                      <strong className="text-white">
                        75% off through 2026
                      </strong>{" "}
                      while spots are available.
                    </p>
                  </div>
                </div>
              </div>

              {/* Offer closes — pinned to bottom */}
              <div className="contact-footer mt-6 pt-4 border-t border-white/10 flex items-center gap-2">
                <span
                  className="w-1.5 h-1.5 rounded bg-amber-400 flex-shrink-0"
                  style={{
                    animation: "shimmer-crown 1.8s ease-in-out infinite",
                  }}
                />
                <span className="text-[10px] text-white/55 font-medium whitespace-nowrap">
                  Offer ends 30 September 2026
                </span>
              </div>
            </div>

            {/* Right form */}
            <div className="lg:col-span-3 bg-white p-6">
              <div id="hubspotFormContainer"></div>
              {/* <p className="text-xs font-bold tracking-widest text-[#9a9aaa] uppercase mb-6">Register Your Interest</p>

              {status === 'success' ? (
                <div className="flex flex-col items-center justify-center py-12 text-center gap-4">
                  <div className="w-14 h-14 flex items-center justify-center bg-[#e8f5e9] rounded">
                    <i className="ri-check-line text-2xl text-[#2e7d32]"></i>
                  </div>
                  <h4 className="text-lg font-bold text-[#1a1a2e]">You're on the list!</h4>
                  <p className="text-md text-[#6a6a7a] max-w-sm">Thanks for registering interest. We'll be in touch soon with your early access details.</p>
                </div>
              ) : (
                <form data-readdy-form="true" className="grid grid-cols-1 sm:grid-cols-2 gap-5" onSubmit={handleSubmit}>
                  <div className="sm:col-span-2">
                    <label className="block text-xs font-semibold text-[#1a1a2e] mb-1.5">Email <span className="text-red-500">*</span></label>
                    <input required type="email" name="email" placeholder="you@yourfirm.co.uk" className="w-full border border-[#D0C9BE] rounded px-3 py-2.5 text-md text-[#1a1a2e] bg-[#FDFAF6] placeholder-[#9a9aaa] outline-none focus:border-[#1a1a2e] transition-colors" />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-[#1a1a2e] mb-1.5">Last Name <span className="text-red-500">*</span></label>
                    <input required name="last_name" placeholder="Smith" className="w-full border border-[#D0C9BE] rounded px-3 py-2.5 text-md text-[#1a1a2e] bg-[#FDFAF6] placeholder-[#9a9aaa] outline-none focus:border-[#1a1a2e] transition-colors" />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-[#1a1a2e] mb-1.5">Phone Number <span className="text-red-500">*</span></label>
                    <input required type="tel" name="phone_number" placeholder="+44 7700 000000" className="w-full border border-[#D0C9BE] rounded px-3 py-2.5 text-md text-[#1a1a2e] bg-[#FDFAF6] placeholder-[#9a9aaa] outline-none focus:border-[#1a1a2e] transition-colors" />
                  </div>
                  <div className="sm:col-span-2">
                    <label className="block text-xs font-semibold text-[#1a1a2e] mb-1.5">Company Name <span className="text-red-500">*</span></label>
                    <input required name="company_name" placeholder="Your IFA firm" maxLength={500} className="w-full border border-[#D0C9BE] rounded px-3 py-2.5 text-md text-[#1a1a2e] bg-[#FDFAF6] placeholder-[#9a9aaa] outline-none focus:border-[#1a1a2e] transition-colors" />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-[#1a1a2e] mb-1.5">I am a <span className="text-red-500">*</span></label>
                    <select name="role" required className="w-full border border-[#D0C9BE] rounded px-3 py-2.5 text-md text-[#1a1a2e] bg-[#FDFAF6] outline-none focus:border-[#1a1a2e] transition-colors cursor-pointer">
                      <option value="" disabled>Please Select</option>
                      <option value="Financial Planner">Financial Planner</option>
                      <option value="IFA / Independent Planner">IFA / Independent Planner</option>
                      <option value="Wealth Manager">Wealth Manager</option>
                      <option value="Financial Planner">Financial Planner</option>
                      <option value="Compliance Officer">Compliance Officer</option>
                      <option value="Client">Client</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-[#1a1a2e] mb-1.5">How did you hear about us? <span className="text-red-500">*</span></label>
                    <select name="referral_source" required className="w-full border border-[#D0C9BE] rounded px-3 py-2.5 text-md text-[#1a1a2e] bg-[#FDFAF6] outline-none focus:border-[#1a1a2e] transition-colors cursor-pointer">
                      <option value="" disabled>Please Select</option>
                      <option value="LinkedIn">LinkedIn</option>
                      <option value="Google Search">Google Search</option>
                      <option value="Social Media">Social Media</option>
                      <option value="Colleague Referral">Colleague Referral</option>
                      <option value="Industry Event">Industry Event</option>
                      <option value="News Article">News Article</option>
                    </select>
                  </div>
                  <div className="sm:col-span-2 flex flex-col gap-3">
                    <label className="flex items-start gap-2.5 cursor-pointer">
                      <input type="checkbox" name="consent_communications" value="yes" className="mt-0.5 accent-[#1a1a2e] cursor-pointer" />
                      <span className="text-xs text-[#6a6a7a] leading-relaxed">I agree to receive other communications from Envizage.</span>
                    </label>
                    <label className="flex items-start gap-2.5 cursor-pointer">
                      <input required type="checkbox" name="consent_data" value="yes" className="mt-0.5 accent-[#1a1a2e] cursor-pointer" />
                      <span className="text-xs text-[#6a6a7a] leading-relaxed">I agree to allow Envizage to store and process my personal data. <span className="text-red-500">*</span></span>
                    </label>
                  </div>
                  <div className="sm:col-span-2">
                    {status === 'error' && <p className="text-xs text-red-500 mb-3">Something went wrong. Please try again.</p>}
                    <button type="submit" disabled={status === 'sending'} className="w-full bg-[#222] text-white font-semibold text-md py-3 rounded hover:bg-[#000] transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60 disabled:cursor-not-allowed">
                      {status === 'sending' ? 'Submitting...' : 'Get Started'}
                    </button>
                  </div>
                </form>
              )} */}
            </div>
          </div>
        </AnimateOnScroll>
      </div>
    </section>
  );
}
